module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/collab/collab-scroll-06-0c68a3868384941035a7fd07879d3ccb.jpg";